import CalendarPage from "./CalendarPage";

export const CalendarPageConfig = {
  routes: [
    {
      path: "/pages/calendar",
      exact: true,
      component: CalendarPage
    }
  ]
};
